import React from 'react';
import TimelineIcon from '@mui/icons-material/Timeline';
import { ISvgProps } from './_module/Svg';

interface IProps extends Omit<ISvgProps, 'svgIcon' | 'viewBox'> {}

export default function KeepitalLogAppSvg(props: IProps) {
  const { width, height } = props;
  return (
    <TimelineIcon
      style={{
        width,
        height,
      }}
    />
  );
}
